import { breakpoint, colors, fontFamily, mediaQueryHelper } from '@offerzen/pinata'
import { css } from '@emotion/css'

const CUSTOM_DESKTOP_BREAKPOINT = 1024

const styles = {
  backgroundContainer: css({
    backgroundColor: '#131F4A',
    color: colors.white,
    fontFamily: fontFamily.heading,
    position: 'relative',
    overflow: 'visible',
    height: 'auto',
    marginTop: 62, // To offset Navigation bar height

    [mediaQueryHelper(breakpoint.phone)]: {
      backgroundColor: '#132254',
    },
  }),

  flexContainer: css({
    display: 'flex',
    position: 'relative',
    flexDirection: 'row',
    gap: '0px',
    margin: 'auto',
    width: 'auto',
    padding: '24px 24px 0 24px',
    alignItems: 'center',
    marginBottom: 0,
    justifyContent: 'space-between',
    overflow: 'hidden',

    [mediaQueryHelper(breakpoint.phone)]: {
      maxWidth: '1070px',
      gap: '24px',
      height: '100%',
      padding: '60px 40px 0px 40px',
      marginBottom: 0,
    },

    [mediaQueryHelper(breakpoint.tablet)]: {
      padding: '100px 30px 0px 40px',
      marginBottom: '24px',
    },
  }),

  headerText: css({
    margin: 'auto 0',
    width: 'auto',

    [mediaQueryHelper(breakpoint.phone)]: {
      width: '70%',
    },

    [mediaQueryHelper(breakpoint.tablet)]: {
      width: '55%',
    },
  }),

  title: css({
    fontSize: '1.75rem',
    lineHeight: '2rem',

    [mediaQueryHelper(breakpoint.phone)]: {
      fontSize: '2.5rem',
      lineHeight: '3.125rem',
    },
  }),

  hyperlinkText: css({
    color: colors.cornflowerBlue,
    textDecoration: 'none',
  }),

  desktopHeaderImageContainer: css({
    position: 'relative',
    marginTop: 10,
    display: 'none',

    [mediaQueryHelper(CUSTOM_DESKTOP_BREAKPOINT)]: {
      display: 'block',
    },
  }),

  mobileHeaderImageContainer: css({
    position: 'relative',
    marginTop: 10,
    display: 'none',

    [mediaQueryHelper(breakpoint.phone)]: {
      position: 'absolute',
      right: '-13%',
      display: 'block',
    },

    [mediaQueryHelper(breakpoint.tablet)]: {
      position: 'relative',
      right: 'unset',
      display: 'block',
    },

    [mediaQueryHelper(CUSTOM_DESKTOP_BREAKPOINT)]: {
      display: 'none',
    },
  }),

  filtersContainer: css({
    background: '#131F4A',

    [mediaQueryHelper(breakpoint.phone)]: {
      background: '#132254',
    },

    [mediaQueryHelper(breakpoint.tablet)]: {
      background: `linear-gradient(180deg, #132254 50%, ${colors.catskillWhite} 50%)`,
      paddingBottom: 12,
    },
  }),

  filtersWhiteBackground: css({
    background: 'transparent',
    padding: '0px 24px 40px 24px',
    maxWidth: 'unset',

    [mediaQueryHelper(breakpoint.phone)]: {
      padding: 40,
      paddingTop: 0,
    },

    [mediaQueryHelper(breakpoint.tablet)]: {
      background: colors.white,
      padding: 40,
      boxShadow: '4px 4px 10px rgba(19, 34, 84, 0.15)',
      maxWidth: '85%',
      borderRadius: 10,
      margin: 'auto',
    },

    [mediaQueryHelper(breakpoint.desktop)]: {
      maxWidth: 997,
    },
  }),
}

export default styles
